import {useMutation} from '@tanstack/react-query';
import queryClient from '@/utils/reactQueryClient';
import vettingUpdaters from '@/api/updaters/vetting';
import type {BatchCreateResponse} from '@/api/updaters/vetting';
import {queryKey as resultsQueryKey} from '@/hooks/queries/use-creator-brand-safety-vettings-query';

function useBatchCreateVetting({brandId}: {brandId: string}) {
  return useMutation({
    mutationKey: ['vetting', 'batchCreate'],
    mutationFn: vettingUpdaters.batchCreate,
    onSettled: () => {
      queryClient.invalidateQueries({queryKey: [resultsQueryKey, brandId]});
    },
  });
}

export type {BatchCreateResponse};
export default useBatchCreateVetting;
